<!--首页 我绑定的考级中心 详情-->
<template>
  <div class="gray-back kaoji-box" style="padding:.2rem 0 1rem 0 ;  height: 100%">
    <div style="margin:0 .2rem .2rem 0;text-align: right">
      <van-button @click="unbind">解绑</van-button>
    </div>
    <div class="kaoji-title">{{ row.danwei }}{{ row.kaojitype }}</div>

    <van-cell-group>
      <div class="kaoji-img">
        <img :src="row.zhizhao_pic_url" alt="" style="width: 100%">
      </div>
      <van-cell title="考级单位名称" :value="row.danwei"></van-cell>
      <van-cell title="考级单位级别" :value="row.kaojitype"></van-cell>
      <van-cell title="考级单位地址" :value="row.address"></van-cell>
      <van-cell title="客服电话" :value="row.contactsphone"></van-cell>
      <div style="height: 10px"></div>

    </van-cell-group>

    <div class="savebtn">
      <van-button
          style="width: 3rem"
          size="normal" round v-rblink="{name: 'QcxjDetailInfo', query: {status: 1}}">资讯
      </van-button>
      <van-button
          style="width: 3rem"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          size="normal" round @click="toKaoji">考级
      </van-button>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.kaoji-box .van-cell__value {
  color: #323233;
}

.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-img {
  text-align: center;
  margin-top: .3rem;
}

.bottom-img img {
  width: 5rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'QcxjDetailMine',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {},
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.id = this.$route.query.id;
    document.title = "我的七彩星级"

    that.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/examecenter/centerdetail', {
        id: that.id
      }, (res) => {
        that.areaValue = res.data.province + ' ' + res.data.city + ' ' + res.data.county
        that.row = res.data;
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },



    // 解绑
    unbind() {
      let that = this;

      Dialog.confirm({
        title: '解绑',
        message: '确定解绑吗?'
      }).then(() => {
        // on confirm
        that.$api.get('/api/exameCenter/centerUserUnBind', {
          center_id: that.row.id,
        }, (res) => {
          Toast.success('解绑成功')
          rbLink({
            'name': 'QcxjSearchIndex',
          }, 'back')
        })
      }).catch(() => {
        // on cancel
      });
    },

    toKaoji() {
      rbLink({
        name: 'QcxjDetailInfo',
        query: {
          id: this.row.id
        }
      })
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// QcxjDetailMine.vue?2a99e354